const initBlogFilters = () => {
    const filterContainer = document.querySelector('.globalHeaderBack.blogs.mainView');
    const postsContainer = document.querySelector('.o-grid--blog');
    const loadMoreBtn = document.querySelector('.js-load-more-posts');
    
    if (!filterContainer || !postsContainer) {
        return;
    }

    // Check if AJAX object is available
    if (typeof loadMorePostsAjax === 'undefined') {
        console.warn('Blog Filters: AJAX object not available');
        return;
    }

    const searchForm = filterContainer.querySelector('form');
    const searchInput = filterContainer.querySelector('#search');
    const categorySelect = filterContainer.querySelector('#category-filter');
    const sortLinks = filterContainer.querySelectorAll('.filter-link');
    
    let isLoading = false;
    let debounceTimer = null;

    // Initialize filters from URL parameters
    const initFiltersFromURL = () => {
        const urlParams = new URLSearchParams(window.location.search);
        
        // Set search value
        if (searchInput) {
            const urlSearch = urlParams.get('s');
            if (urlSearch) {
                searchInput.value = urlSearch;
            }
        }
        
        // Set category
        if (categorySelect) {
            const urlCat = urlParams.get('cat');
            if (urlCat) {
                categorySelect.value = urlCat;
            }
        }
        
        // Set sort
        const urlSort = urlParams.get('sort') || 'newest';
        sortLinks.forEach(link => {
            if (link.dataset.sort === urlSort) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
        
        // If there are URL parameters, apply filters
        if (urlParams.has('s') || urlParams.has('cat') || urlParams.has('sort')) {
            // Small delay to ensure DOM is ready
            setTimeout(() => {
                const filters = getFilterValues();
                updatePosts(filters);
            }, 100);
        }
    };

    // Helper function to get current filter values
    const getFilterValues = () => {
        return {
            search: searchInput?.value.trim() || '',
            category: categorySelect?.value || '',
            sort: filterContainer.querySelector('.filter-link.active')?.dataset.sort || 'newest'
        };
    };

    // Initialize filters from URL on page load
    initFiltersFromURL();

    // Function to update posts via AJAX
    const updatePosts = (filters) => {
        if (isLoading) return;

        isLoading = true;
        postsContainer.classList.add('is-loading');
        
        // Disable load more button during filtering
        if (loadMoreBtn) {
            loadMoreBtn.style.display = 'none';
        }

        fetch(loadMorePostsAjax.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'filter_posts',
                search: filters.search,
                category: filters.category,
                sort: filters.sort,
                nonce: loadMorePostsAjax.filter_nonce || loadMorePostsAjax.nonce
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Clear existing posts
                postsContainer.innerHTML = '';
                
                if (data.data.html) {
                    // Create a temporary container to parse HTML
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data.data.html;
                    
                    // Get all article elements
                    const newPosts = tempDiv.querySelectorAll('.c-article');
                    
                    // Append new posts to container
                    newPosts.forEach(post => {
                        postsContainer.appendChild(post);
                    });
                }

                // Update Load More button
                if (loadMoreBtn) {
                    if (data.data.has_more) {
                        loadMoreBtn.style.display = '';
                        loadMoreBtn.dataset.maxPages = data.data.max_pages;
                        // Reset pagination in loadMore script if available
                        if (typeof window.resetLoadMorePagination === 'function') {
                            window.resetLoadMorePagination(data.data.max_pages);
                        }
                    } else {
                        loadMoreBtn.style.display = 'none';
                        if (typeof window.resetLoadMorePagination === 'function') {
                            window.resetLoadMorePagination(1);
                        }
                    }
                }

                // Update URL without page reload (for sharing/bookmarking)
                const url = new URL(window.location);
                if (filters.search) {
                    url.searchParams.set('s', filters.search);
                } else {
                    url.searchParams.delete('s');
                }
                if (filters.category) {
                    url.searchParams.set('cat', filters.category);
                } else {
                    url.searchParams.delete('cat');
                }
                if (filters.sort && filters.sort !== 'newest') {
                    url.searchParams.set('sort', filters.sort);
                } else {
                    url.searchParams.delete('sort');
                }
                window.history.pushState({}, '', url);

                // Scroll to top of posts (optional, smooth scroll)
                postsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                console.error('Error filtering posts:', data.data?.message || 'Unknown error');
            }
        })
        .catch(error => {
            console.error('AJAX error:', error);
        })
        .finally(() => {
            isLoading = false;
            postsContainer.classList.remove('is-loading');
        });
    };

    // Handle search form submission
    if (searchForm) {
        searchForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const filters = getFilterValues();
            updatePosts(filters);
        });
    }

    // Handle search input with debounce (optional - for real-time search)
    if (searchInput) {
        // Only trigger on Enter key or after typing stops for 500ms
        searchInput.addEventListener('keyup', function(e) {
            if (e.key === 'Enter') {
                const filters = getFilterValues();
                updatePosts(filters);
                return;
            }

            // Debounce: wait 500ms after user stops typing
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                // Only auto-search if there's a value
                if (searchInput.value.trim()) {
                    const filters = getFilterValues();
                    updatePosts(filters);
                }
            }, 500);
        });
    }

    // Handle category select change
    if (categorySelect) {
        categorySelect.addEventListener('change', function() {
            const filters = getFilterValues();
            updatePosts(filters);
        });
    }

    // Handle sort link clicks
    sortLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Remove active class from all links
            sortLinks.forEach(l => l.classList.remove('active'));
            
            // Add active class to clicked link
            this.classList.add('active');
            
            const filters = getFilterValues();
            updatePosts(filters);
        });
    });

    // Initialize mobile accordion
    let accordionInitialized = false;
    
    const initMobileAccordion = () => {
        const isMobile = window.innerWidth < 992;
        
        // Only initialize once on mobile
        if (!isMobile || accordionInitialized) {
            return;
        }

        accordionInitialized = true;

        // Main toggle button
        const mainToggle = filterContainer.querySelector('.blog-filters-toggle');
        const filtersContainer = filterContainer.querySelector('.blog-filters-container');
        
        if (mainToggle && filtersContainer) {
            mainToggle.addEventListener('click', function() {
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                this.setAttribute('aria-expanded', !isExpanded);
                filtersContainer.classList.toggle('is-open', !isExpanded);
            });
        }

        // Individual accordion items
        const accordionHeaders = filterContainer.querySelectorAll('.blog-filter-accordion-header');
        
        accordionHeaders.forEach(header => {
            header.addEventListener('click', function() {
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                const content = this.nextElementSibling;
                
                if (!content) return;
                
                // Toggle this item
                this.setAttribute('aria-expanded', !isExpanded);
                content.classList.toggle('is-open', !isExpanded);
                
                // Optional: Close other items when opening one (accordion behavior)
                // Uncomment if you want only one open at a time
                // if (!isExpanded) {
                //     accordionHeaders.forEach(otherHeader => {
                //         if (otherHeader !== this) {
                //             otherHeader.setAttribute('aria-expanded', 'false');
                //             const otherContent = otherHeader.nextElementSibling;
                //             if (otherContent) {
                //                 otherContent.classList.remove('is-open');
                //             }
                //         }
                //     });
                // }
            });
        });
    };

    // Initialize accordion on load
    initMobileAccordion();
}

export { initBlogFilters };

